module.exports = __webpack_public_path__ + "static/media/logo_sustantibility.17273a9f.png";